import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { APIKey } from 'constants/apiKeys';
import routesConfig from 'constants/routesConfig.json';
import useWebsocketSetup from 'shared/hooks/useWebsocketSetup';
import { Note } from 'shiftNotes/_types';

interface ShiftNoteUpdatedMessage {
  type: 'shift_note_updated';
  shift_note: Note;
}

export default function useShiftNoteUpdates(enabled: boolean = true) {
  const queryClient = useQueryClient();
  const shiftNotesWs =
    typeof routesConfig.SHIFT_NOTES === 'string'
      ? routesConfig.SHIFT_NOTES
      : routesConfig.SHIFT_NOTES.WS;
  const { lastJsonMessage } = useWebsocketSetup<ShiftNoteUpdatedMessage>(
    shiftNotesWs,
    enabled
  );

  useEffect(() => {
    if (!lastJsonMessage || lastJsonMessage.type !== 'shift_note_updated')
      return;

    const updatedNote = lastJsonMessage.shift_note;

    queryClient.setQueryData<Note | undefined>(
      [APIKey.SHIFT_NOTE, updatedNote.id],
      (oldData) => (oldData ? { ...oldData, ...updatedNote } : updatedNote)
    );

    queryClient.invalidateQueries({ queryKey: [APIKey.EVENT] });
  }, [lastJsonMessage, queryClient]);
}
